export default __webpack_public_path__ + "static/media/billing-overall-gray.a62dc208.svg";